import { render, staticRenderFns } from "./FormControlTrix.vue?vue&type=template&id=123459ec"
import script from "./FormControlTrix.vue?vue&type=script&lang=js"
export * from "./FormControlTrix.vue?vue&type=script&lang=js"
import style0 from "./FormControlTrix.vue?vue&type=style&index=0&id=123459ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports